import React from 'react';
import { Group, Text, Anchor } from '@mantine/core';
import appSettings from '../../appsettings.json';

const Footer: React.FC = () => {
	return (
		<>
			<Group>
				<Text size="xs">&copy; 2024 Conduction, Inc. All rights reserved</Text>
			</Group>

			<Group>
				<Text size="xs">Version {appSettings.Version}</Text>
			</Group>

			<Group>
				<Anchor
					href="https://docs.google.com/document/d/1ErgPJORWHHJrvAY8USGhaPG0Wa9AEa-O/edit?usp=sharing&ouid=115620778392196722500&rtpof=true&sd=true"
					target="_blank"
					size="xs"
				>
					COPPA Notice
				</Anchor>
			</Group>
		</>
	);
};

export default Footer;
